var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "选择图片",
        width: "800px",
        visible: _vm.visible,
        "append-to-body": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "picture-card-list-wrapper" },
        [
          _vm._l(_vm.imgs, function (item, i) {
            return _c(
              "div",
              {
                key: i,
                staticClass: "avatar-item",
                style: "width:" + _vm.size + ";height:" + _vm.size + ";",
                on: {
                  click: function ($event) {
                    return _vm.choose(item)
                  },
                },
              },
              [
                _c("el-image", {
                  staticClass: "avatar-item-img",
                  attrs: { src: item, fit: "contain" },
                }),
                _c("el-checkbox", {
                  staticClass: "top-left",
                  attrs: { label: "", value: item === _vm.selectImg },
                  nativeOn: {
                    change: function ($event) {
                      $event.stopPropagation()
                      return _vm.choose(item)
                    },
                  },
                }),
              ],
              1
            )
          }),
          _c(
            "el-upload",
            {
              staticClass: "avatar-uploader avatar-item",
              style: "width:" + _vm.size + ";height:" + _vm.size + ";",
              attrs: {
                action: "",
                "show-file-list": false,
                multiple: _vm.multiple,
                "on-change": _vm.handleFileChange,
                "http-request": _vm.uploadFile,
                "before-upload": _vm.beforeAvatarUpload,
              },
            },
            [
              _vm.loading
                ? [
                    _c("el-progress", {
                      attrs: {
                        "show-text": false,
                        "stroke-width": 1,
                        percentage: _vm.process,
                        color: "#3a416f",
                      },
                    }),
                  ]
                : [_c("span", { staticClass: "up-icon" }, [_vm._v("+")])],
            ],
            2
          ),
        ],
        2
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              staticClass: "el-button--small f-btn",
              attrs: { type: "primary", disabled: !_vm.selectImg },
              on: { click: _vm.confirm },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }